import { replaceTrailingSlash } from '../../../../common/util/string';
import { customFetch } from '../helpers/buildFetch';
import { CheckEnrollResponse } from '../lib/3DS/interface';

const baseUrl = `${replaceTrailingSlash(import.meta.env.VITE_BASE_URL)}api/3ds`;

export const generateJWT = async ({ data }: { data: any }) => {
  try {
    const url = `${baseUrl}/generate`;
    return await customFetch(url, {
      method: 'POST',
      data,
    });
  } catch (e) {
    throw e;
  }
};

export const checkEnroll = async ({ data }: { data: any }): Promise<CheckEnrollResponse> => {
  try {
    const url = `${baseUrl}/check-enroll`;
    return await customFetch(url, {
      method: 'POST',
      data,
    });
  } catch (e) {
    throw e;
  }
};

/**
 * The only call here that retries on timeout. By the time it runs the cardholder has already
 * authenticated, so a lost response means an approved authentication we never record and a
 * charge that later expires as if it had failed -- retrying is the difference between
 * recovering it and dropping it.
 *
 * Rests on validate being safe to repeat for the same authenticationTransactionID: it reads
 * back an existing authentication rather than creating one. Worth confirming with the
 * backend; if it is not, drop retryOnTimeout and the call simply fails faster.
 */
export const validate = async ({ data }: { data: any }) => {
  try {
    const url = `${baseUrl}/validate`;
    return await customFetch(url, {
      method: 'POST',
      data,
      retryOnTimeout: true,
    });
  } catch (e) {
    throw e;
  }
};
